import { DashboardLayoutType, IDashboardComponent } from "./DashboardComponent";
import { DashboardComponentGroupReportOptions } from "./DashboardReportOptions";

export enum DashboardComponentJustify {
  START = "START",
  END = "END",
  CENTER = "CENTER",
  BETWEEN = "BETWEEN",
  AROUND = "AROUND",
  EVENLY = "EVENLY",
}

export enum DashboardComponentAlign {
  STRETCH = "STRETCH",
  START = "START",
  END = "END",
  CENTER = "CENTER",
}

export interface DashboardComponentGroupLayout {
  type: DashboardLayoutType;
  gap?: number;
  justify?: DashboardComponentJustify;
  align?: DashboardComponentAlign;
  componentHeight?: number;
}

export interface DashboardComponentGroup {
  id: string;
  title: string;
  components: Array<IDashboardComponent>;
  layout: DashboardComponentGroupLayout;
  reportOptions?: DashboardComponentGroupReportOptions;
}
